(function () {
  function initSection(section) {
    if (section.dataset.aboutItInit === '1') return;
    section.dataset.aboutItInit = '1';

    const dots = section.querySelectorAll('.about-it__dot');
    const cards = section.querySelectorAll('[data-hotspot-card]');

    function closeAll() {
      cards.forEach((c) => c.setAttribute('hidden', ''));
      dots.forEach((d) => d.setAttribute('aria-expanded', 'false'));
    }

    function openCard(id) {
      cards.forEach((c) => {
        if (c.id === id) c.removeAttribute('hidden');
        else c.setAttribute('hidden', '');
      });
      dots.forEach((d) => {
        d.setAttribute('aria-expanded', d.dataset.hotspotTarget === id ? 'true' : 'false');
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.stopPropagation();
        const id = dot.dataset.hotspotTarget;
        const target = section.querySelector('#' + CSS.escape(id));
        if (target && target.hasAttribute('hidden')) openCard(id);
        else closeAll();
      });
    });

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-hotspot-card]')) return;
      if (e.target.closest('.about-it__dot')) return;
      closeAll();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });
  }

  function initAll() {
    document.querySelectorAll('.about-it').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector) {
      e.target.querySelectorAll('.about-it').forEach(initSection);
    }
  });
})();
